export default __webpack_public_path__ + "static/media/hht1_ep01_timeline_q02_b.eb7acfda.png";